import React from 'react'
import styles from 'components/Shared/DateTimeWithZoneCell/DateTimeWithZoneCell.module.css'
import moment from 'moment-timezone'

export function DateTimeWithZoneCell ({ dateTime, timeZone, className }) {

  function convertDateToTimeZoneAbbr (date, zone) {
    const timeZoneAbbr = moment(date).tz(zone).zoneAbbr()
    return timeZoneAbbr.match(/^[+-](.*)/) ? 'UTC'+timeZoneAbbr : timeZoneAbbr
  }

  return <div className={className}>
    <p>{moment(dateTime).format('HH:mm')}</p>
    &nbsp;<p className={styles.superscriptText}>{convertDateToTimeZoneAbbr(dateTime, timeZone)}</p>
  </div>
}
